<template>
  <div>
    <br />

    <!-- <vue-action-buttons :buttons="actionButtons">

      <template #cell-button name="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          >
          
        </span>
      </template>
</vue-action-buttons> -->

    <vue-action-buttons :buttons="actionButtons" />
    <!-- <template #cell-button="{ row }">
        <span class="px-2 py-1 rounded" >
          <button @click="validateOrder(row.reference)" class="btn btn-outline-success">
            <i class="bi bi-check2-square"></i> Valider
          </button>
        </span>
      </template>
    </vue-action-buttons> -->


    <vue-order-details :order="order" :reference="$route.params.reference" />

    <br> 

    <vue-data-table v-if="order.orderItems" :headers="headers" :data="order.orderItems" :items-per-page="10"
      :buttons="buttons">

      <template #cell-priceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.priceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.priceTTC }}
        </span>
      </template>


      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

    </vue-data-table>
    <br />
    <br />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: 'itemFullName', label: 'Désignation', class: '' },
        { field: 'priceTTC', label: 'Prix', class: 'fw-bold' },
        { field: 'quantity', label: 'Quantité', class: 'fw-bold' },
        { field: 'totalPriceTTC', label: ' Total ', class: 'fw-bold' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      // Button actions
      buttons: [

      ],
      // Columns to summarize

      actionButtons: [
        {
          label: "Valider",
          class: "btn btn-outline-success",
          icon: "bi bi-check2-square",
          action: () => this.validated(this.reference),
          condition: () => this.order.validated !== true && this.$userRole === 'Admin',
        },

        {
          label: "Anuller",
          class: "btn btn-outline-success",
          icon: "bi bi-check2-square",
          action: () => this.cancelValidated(this.reference),
          condition: () => this.order.validated === true && this.$userRole === 'Admin',
        },

        {
          label: "Generer BL",
          class: "btn btn-outline-success",
          icon: "bi bi-check2-square",
          action: () => this.addOrderToSale(this.reference),
          condition: () => this.order.validated != true || this.$userRole === 'Admin',
        },
        {
          label: "Modifier",
          class: "btn btn-outline-primary",
          icon: "bi bi-pencil-square",
          action: () => this.editOrder(this.reference),
          condition: () => this.$userRole === 'Admin' || this.$userRole === 'Commercial' ||
            (this.order.validated != true && this.$userRole === 'Magasinier'),
        },
         {
          label: "Choisir les stocks",
          class: "btn btn-outline-primary",
          icon: "bi bi-pencil-square",
          action: () => this.$router.push({ name: "orders-to-sale", params: { reference: this.reference } }),
          condition: () => this.$userRole === 'Admin' || this.$userRole === 'Commercial' ||
            (this.order.validated != true && this.$userRole === 'Magasinier'),
        },

        {
          label: "Livré",
          class: "btn btn-outline-info",
          icon: "bi bi-truck",
          action: () => this.markAsDelivered(this.reference),
        },

        {
          label: "Annuler Livraison",
          class: "btn btn-outline-danger",
          icon: "bi bi-x-circle",
          action: () => this.cancelDelivery(this.reference),
          condition: () => this.order.deliveryDateTime && this.$userRole === 'Admin', // Bouton affiché uniquement si une date de livraison est définie
        },

        {
          label: "Imprimer BL",
          class: "btn btn-outline-secondary",
          icon: "bi bi-printer",
          action: () => this.printBill(this.reference),
          condition: () => this.$userRole === 'Admin' || this.$userRole === 'Commercial',
        },
        {
          label: "Imprimer BC",
          class: "btn btn-outline-secondary",
          icon: "bi bi-printer",
          action: () => this.printPurchaseOrder(this.reference),
          condition: () => this.$userRole === 'Admin' || this.$userRole === 'Commercial',
        },

        {
          label: "Ticket de Livraison",
          class: "btn btn-outline-secondary",
          icon: "bi bi-printer",
          action: () => this.printDeliveryReceipt(this.reference),
          condition: () => this.$userRole === 'Magasinier' || this.$userRole === 'Commercial',
        },

        {
          label: "Supprimer",
          class: "btn btn-outline-danger",
          icon: "bi bi-trash",
          action: () => this.remove(this.reference),
          condition: () => (this.$userRole === 'Admin' || this.$userRole === 'Commercial') && this.order.validated == false,
        },

        {
          label: "Actualiser",
          class: "btn btn-outline-dark",
          icon: "bi bi-arrow-clockwise",
          action: this.refresh,
        },
      ],
      reference: this.$route.params.reference
    };
  },

  async mounted() {
    await this.$store.dispatch("order/show", this.$route.params.reference);
  },
  computed: {
    ...mapGetters("order", {
      order: "getOrder",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("order/show", this.$route.params.reference);
    },
    async printPurchaseOrder(reference) {
      await this.$store.dispatch("order/printPurchaseOrderPage", reference);
    },

    async printDeliveryReceipt(reference) {
      await this.$store.dispatch("order/printDeliveryReceipt", reference);
    },

    async printBill(reference) {
      await this.$store.dispatch("order/printBillPage", reference);
    },

    async addOrderToSale(reference) {
      await this.$store.dispatch("order/addToSale", reference);
    },

    async validated(reference) {
      await this.$store.dispatch("order/validated", reference);
    },

    async cancelValidated(reference) {
      await this.$store.dispatch("order/cancelValidated", reference);
    },

    async remove(reference) {
      await this.$store.dispatch("order/destroy", reference);
    },

    editOrder(ref) {
      this.$router.push({ name: "orders-items-edit", params: { reference: ref } });
    },
    markAsDelivered(ref) {
      this.$router.push({ name: "orders-delivered", params: { reference: ref } });
    },

    async cancelDelivery(reference) {
      await this.$store.dispatch("order/cancelDelivery", reference);
    },

  },
};
</script>
